import { render, staticRenderFns } from "./LimitSelect.vue?vue&type=template&id=573727f4&"
import script from "./LimitSelect.vue?vue&type=script&lang=js&"
export * from "./LimitSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports